/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { ModelProvider } from "../providers/ModelProvider";
import { bem } from "../shared/BEM";
import { PageSection } from "./PageSection";
import { PageHeader } from "./PageHeader";
import { Page } from "./Page";

/**
 * Component props
 */
export interface IPageModelProps {
	modelProvider: ModelProvider;
	modelId: string;
}

/**
 * Model page component
 *
 * @param props Props
 */
export function PageModel(props: IPageModelProps) {

	const {spec, handler} = useMemo(() => {

		const modelSpec = props.modelProvider.getById(props.modelId);
		const modelHandler = modelSpec ? modelSpec.handlerFactory(modelSpec) : null;

		if (modelHandler) {
			modelHandler.update();
		}

		return {
			spec: modelSpec,
			handler: modelHandler
		};

	}, [ props.modelId ]);

	if (!spec) {
		return <Page>
			<PageHeader
				title="Model nebyl nalezen"
			/>
			<PageSection>
				<p>Prosím zkontrolujte zadanou URL adresu nebo vyberte model z nabídky.</p>
			</PageSection>
		</Page>;
	}

	return <Page>
		<spec.component spec={spec} handler={handler} />
	</Page>;

}
